module.exports = __webpack_public_path__ + "img/251-638975.png";